export var textRowsWrapper = 'min-w-0 flex-1 flex items-center';
export var paragraphWrapper = 'flex flex-col flex-1 min-w-0 px-4';
//# sourceMappingURL=attendance-stacked-list.styles.js.map